import { render } from "./frequencyLimiting.vue?vue&type=template&id=4d64b207&scoped=true"
import script from "./frequencyLimiting.vue?vue&type=script&lang=js"
export * from "./frequencyLimiting.vue?vue&type=script&lang=js"

import "./frequencyLimiting.vue?vue&type=style&index=0&id=4d64b207&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d64b207"

export default script